import { render } from "./AddMutantModal.vue?vue&type=template&id=7168b8ba&scoped=true"
import script from "./AddMutantModal.vue?vue&type=script&lang=js"
export * from "./AddMutantModal.vue?vue&type=script&lang=js"

import "./AddMutantModal.vue?vue&type=style&index=0&id=7168b8ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7168b8ba"]])

export default __exports__